module.exports = __webpack_public_path__ + "img/ct.21b74f5b.png";